/**
 * KEEP IT DUMB AND SIMPLE
 */
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { requestPuppy } from '@wix/da-http-client';
import { makeXHRCall, setIsLoading, storeResult } from './actionCreators';
import { getIsLoading } from './selectors';
import { getFakeResponse } from './fakeResponses';

export function* makeXHRCallHandler({
  payload: { endpoint, method, papiBase, params, data, onComplete, onSuccess, onError },
}: ReturnType<typeof makeXHRCall>): SagaIterator {
  const isLoading = yield select(getIsLoading, endpoint);
  if (isLoading) {
    return;
  }

  yield put(setIsLoading(endpoint));

  const result = yield call(
    requestPuppy,
    {
      method,
      url: endpoint,
      params,
      data,
    },
    getFakeResponse(endpoint),
    papiBase
  );

  yield put(storeResult({ endpoint, result }));

  if (!result || result.error) {
    onError && onError(result);
  } else {
    onSuccess && onSuccess(result);
  }

  onComplete && onComplete();
}

export default function* saga(): any {
  yield takeEvery(makeXHRCall, makeXHRCallHandler);
}
